import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const UseGetContactStatutList = ({ filter }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [contactStatutList, setContactStatutList] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    const getContactStatutList = async () => {

        await fetch(`${apiUrlTranslation}?action=getContactStatutList&filter=${filter}`)
            .then(res => res.json())
            .then(res => setContactStatutList(res))
    }

    useEffect(() => {
        getContactStatutList().then(() => {
            setIsLoading(false);
        });

    }, [i18n.resolvedLanguage])

    return { contactStatutList, isLoading }
}

export default UseGetContactStatutList;